import React, { FunctionComponent, useMemo } from "react";
import { Content } from "@iventis/translations/content/typed-content";
import { CopyableTextPreview } from "@iventis/components";
import { UseIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { API_KEY_QUERY_PARAM_KEY, PROJECT_ID_QUERY_PARAM_KEY } from "@iventis/utilities";
import { useQuery } from "@tanstack/react-query";
import { toast } from "@iventis/toasts/src/toast";
import { createScheduleVersionSharedLink } from "./schedule-api-functions";

export const ShareScheduleLink: FunctionComponent<{ scheduleVersionId: string; projectId: string; translate: UseIventisTranslate }> = ({
    scheduleVersionId,
    projectId,
    translate,
}) => {
    const { data: apiKey } = useQuery(["link"], async () => createScheduleVersionSharedLink(scheduleVersionId));
    const text: string = useMemo(() => (apiKey == null ? null : createSharedLink(apiKey, projectId)), [apiKey]);
    return (
        <>
            <CopyableTextPreview
                fieldLabel={translate(Content.schedule3.shareOrExport.shareLinkLabel)}
                text={text}
                onSuccessfulCopy={() => toast.success({ title: translate(Content.schedule3.shareSchedule), message: translate(Content.common.copied_to_clipboard) })}
            />
        </>
    );
};

const createSharedLink = (apiKey: string, projectId: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    // Delete any search params we are going to add to ensure they are not duplicated.
    searchParams.delete(API_KEY_QUERY_PARAM_KEY);
    searchParams.delete(PROJECT_ID_QUERY_PARAM_KEY);
    searchParams.delete("app-bar");
    const { origin } = window.location;
    const pathName = window.location.pathname;
    searchParams.append(API_KEY_QUERY_PARAM_KEY, apiKey);
    searchParams.append(PROJECT_ID_QUERY_PARAM_KEY, projectId);
    searchParams.append("app-bar", "false");
    return `${origin}${pathName}?${searchParams.toString()}`;
};

export enum ScheduleShareOption {
    LINK,
    EXPORT,
}
